<template>
  <table class="table" :class="{ 'layout-fixed': layoutFixed }">
    <thead>
      <tr>
        <th v-for="{ name, style } in rows" :key="name" :class="style || cellStyleClass">
          {{ name }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="value in valuesToDisplay" :key="value.id">
        <td v-for="{ attribute, style, name, slot } in rows" :key="name" :class="style || cellStyleClass">
          <slot :name="slot" :value="value">
            {{ attribute && attribute(value) }}
          </slot>
        </td>
      </tr>
    </tbody>
    <tfoot v-if="maxTableLength">
      <tr>
        <td>
          {{
            $tc(
              'pluralize.omittedValue',
              (totalValuesCount || values.length) > maxTableLength
                ? (totalValuesCount || values.length) - maxTableLength
                : 0,
            )
          }}
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
export default {
  props: {
    rows: {
      // function or slot: [{ name: 'title', slot: 'name' }, { name: 'title', attribute: value => value.measured_at }]
      type: Array,
      required: true,
    },
    values: {
      type: Array,
      required: true,
      default: () => [],
    },
    maxTableLength: {
      type: Number,
      required: false,
    },
    totalValuesCount: {
      type: Number,
      required: false,
    },
    subtitle: {
      type: String,
      required: false,
    },
    layoutFixed: {
      type: Boolean,
      default: true,
    },
    cellStyleClass: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    valuesToDisplay() {
      return this.values.slice(0, this.maxTableLength)
    },
  },
}
</script>
